import { SET_BULK_FORM_HAS_SUBMITTED } from "constants-lib/actionTypes"

export const setOaklandBulkFormHasSubmitted = (data) => (dispatch) =>
  dispatch({
    type: SET_BULK_FORM_HAS_SUBMITTED,
    payload: data,
  })
